import { useState } from 'react';
import styles from './HubStatusListModal.module.scss';

// Modal listing hubs of a given online status. Company checkboxes work like
// MachineSelector: when none are checked, all hubs are shown.
function HubStatusListModal({ title, hubs = [], onClose, onSelect }) {
  const [companyFilters, setCompanyFilters] = useState({});

  // Hubs with no company fall under "No Company"
  const companyNames = [...new Set(hubs.map(hub => hub.companyName || 'No Company'))].sort();

  const toggleCompanyFilter = name => {
    setCompanyFilters(prev => ({ ...prev, [name]: !prev[name] }));
  };

  const activeCompanies = Object.keys(companyFilters).filter(name => companyFilters[name]);
  const filteredHubs =
    activeCompanies.length === 0
      ? hubs
      : hubs.filter(hub => activeCompanies.includes(hub.companyName || 'No Company'));

  // Close on backdrop click
  const handleBackdropClick = e => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div className={styles.modal} onClick={handleBackdropClick}>
      <div className={styles.modalContent}>
        <div className={styles.modalHeader}>
          <h2 className={styles.modalTitle}>{title}</h2>
          <button
            type="button"
            className={styles.closeButton}
            onClick={onClose}
            aria-label="Close modal"
          >
            ×
          </button>
        </div>

        <div className={styles.categoryFilters}>
          {companyNames.map(name => (
            <label key={name} className={styles.categoryFilterItem}>
              <input
                type="checkbox"
                checked={!!companyFilters[name]}
                onChange={() => toggleCompanyFilter(name)}
              />
              {name}
            </label>
          ))}
        </div>

        <div className={styles.hubList}>
          {filteredHubs.length > 0 ? (
            filteredHubs.map(hub => (
              <button
                type="button"
                key={hub.serial}
                className={styles.hubItem}
                onClick={() => onSelect(hub.serial)}
              >
                <span className={styles.hubName}>
                  {hub.nickname ? `${hub.nickname} (${hub.serial})` : hub.serial}
                </span>
                {hub.companyName && <span className={styles.hubCategory}>{hub.companyName}</span>}
              </button>
            ))
          ) : (
            <div className={styles.noHubs}>No hubs in this status</div>
          )}
        </div>
      </div>
    </div>
  );
}

export default HubStatusListModal;
